/**
 * Compares current caption text length to a max character count where
 * line is likely to break into two lines
 */
export const handleTwoLineCaptions = (
  textTrackContainer: HTMLElement,
  currentText: string | null,
  wordBreak: number,
) => {
  if (!currentText) {
    return;
  }

  if (currentText.length > wordBreak) {
    textTrackContainer.classList.add('two-lines');
  } else {
    textTrackContainer.classList.remove('two-lines');
  }
};

/**
 * Adds appropriate class to captions depending on width of video
 * Calls additional function to handle potential line breaks
 */
export const scaleCaptions = (
  textTrackContainer: HTMLElement,
  currentText: string | null = null,
) => {
  if (!textTrackContainer) {
    return;
  }

  const textTrackWidth = textTrackContainer.offsetWidth;
  handleTwoLineCaptions(textTrackContainer, currentText, 120);
  if (textTrackWidth > 1100) {
    textTrackContainer.classList.add('large');
    handleTwoLineCaptions(textTrackContainer, currentText, 99);
  } else if (textTrackWidth > 800) {
    textTrackContainer.classList.add('medium');
    handleTwoLineCaptions(textTrackContainer, currentText, 85);
  }
};

export const handleCueChange = (textTrackContainer: HTMLElement, textTrack: VTTCue) => {
  textTrackContainer.classList.remove('two-lines');
  if (textTrack) {
    scaleCaptions(textTrackContainer, textTrack.text);
  } else if (textTrackContainer) {
    scaleCaptions(textTrackContainer);
  }
};
